import { combineReducers } from 'redux';
import report from './report';
import nearby from './nearby';
import buoys from './buoys';
import multiCam from './multiCam';
import idealConditions from './idealConditions';
import featuredContent from './featuredContent';

export default combineReducers({
  report,
  nearby,
  buoys,
  idealConditions,
  featuredContent,
  multiCam,
});
